import React from 'react';

import { Box, Card, Container, Grid } from '@mui/material';

import { SendRequestForm } from './send-request-form';
import { SupportNumberCard } from './support-number-card';
import { useSupportPageStyles } from './support-page-styles';

export type ContactSupportContainerProps = {
  showSupportNumber?: boolean;
};

export const ContactSupportContainer: React.VFC<ContactSupportContainerProps> = ({ showSupportNumber = true }) => {
  const { classes } = useSupportPageStyles();

  return (
    <Container className={classes.container}>
      <Grid container className={classes.grid}>
        <Box className={classes.gridItem}>
          <Card className={classes.cardLeft}>
            <SendRequestForm />
          </Card>
        </Box>
        {showSupportNumber && <SupportNumberCard />}
      </Grid>
    </Container>
  );
};
